import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { appConfig } from './app.config';

// Previously an inline <script> in index.html. Moved here so it ships as part
// of the bundled JS instead of an inline script tag, allowing the CSP
// script-src directive to drop 'unsafe-inline' without breaking Adobe
// Analytics (which reads window.analyticsDataLayer once its external script
// loads further below).
(window as any).analyticsDataLayer = {
  pageInfo: {
    pageName: '',
    userID: '',
    applicationName: '',
    buttonName: ''
  }
};

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

  let cookieScript = document.createElement("script");
  cookieScript.type = "text/javascript";
  cookieScript.async = true;
  cookieScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  cookieScript.setAttribute("data-domain-script",environment.COOKIE_CONSENT_KEY);
  document.body.appendChild(cookieScript);
  
  let launchScript = document.createElement('script');
  launchScript.type = 'text/javascript';
  launchScript.async = true;
  launchScript.src = environment.ADOBE_ANALYTICS;
  document.getElementsByTagName('head')[0].appendChild(launchScript);